import { machineSubMapping } from '@internal/utils/machine/i18n/machineSubMapping'
import { TranslationJsonType } from '@internal/utils/machine/i18n/Translation'
import { SubTypes } from '@internal/utils/machine/MachineType'
import { translations } from 'i18n/translations'

const mapping = machineSubMapping(translations)

export const machineSubTypeTranslationKeyMapping = mapping as any as Record<
  SubTypes[keyof SubTypes],
  keyof TranslationJsonType
>
